import { withBoxModel } from "../withBoxModel/withBoxModel";
import { Button as BaseButton } from "./button";

const Button = withBoxModel(BaseButton);
export { Button };
